import { render, staticRenderFns } from "./RegularLineTable.vue?vue&type=template&id=287494e2&scoped=true&"
import script from "./RegularLineTable.vue?vue&type=script&lang=js&"
export * from "./RegularLineTable.vue?vue&type=script&lang=js&"
import style0 from "./RegularLineTable.vue?vue&type=style&index=0&id=287494e2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "287494e2",
  null
  
)

export default component.exports